import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import BlankTemplatePage from '../_blank_template_page';
import ListTemplatePage from '../_list_template_page';

const UnknownPage = () => {
  const blankOrList = useSelector((state) => state.currentTab.type);

  return (
    <div className={styles.unknownPage}>
      {blankOrList === 'tab_blank' ? (
        <BlankTemplatePage />
      ) : blankOrList === 'tab_list' ? (
        <ListTemplatePage />
      ) : (
        <>
          <h2 className={styles.title}>Раздел неопределен</h2>
          <p className={styles.description}>Раздел неопределен</p>
        </>
      )}
    </div>
  );
};

export default UnknownPage;
